import React, { useState, useEffect } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import NoDataFound from "../../../partials/NoDataFound"
import { trans } from "../../../../_providers/Translation"
import WarrantyOptions from "../list/WarrantyOptions"
import moment from "moment"
import alertImage from "@/assets/img/contractors/icons/alert.svg"
import { Tooltip } from "@mui/material"
import Pagination from "@/components/Pagination"

export default function GuaranteesList({
  handleEdit,
  handleDelete,
  handleActivate,
  handleRenew,
  handleDeactivate,
  refresh,
}) {
  const [data, setData] = useState({
    loading: true,
    data: [],
    page: 1,
    pages: 0,
    update: false,
  })

  useEffect(() => {
    loadWarranties()
  }, [refresh, data.update])

  const loadWarranties = () => {
    setData((prev) => ({
      ...prev,
      loading: true,
    }))

    let url = "contractors/warranties?page=" + data.page

    Api.get(url)
      .then((res) => {
        setData((prev) => ({
          ...prev,
          loading: false,
          data: res.data.items,
          pages: res.data.pages,
        }))
      })
      .catch(() => {
        setData((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const handlePage = (page) => {
    setData((prev) => ({
      ...prev,
      page: page.selected + 1,
      update: new Date().getTime(),
    }))
  }

  return (
    <div className="pannel">
      {data.loading ? (
        <Skeleton height={45} count={10} />
      ) : data.data.length === 0 ? (
        <NoDataFound message={trans("messages.noAddedWarranties")} />
      ) : (
        <>
          <div className="table-scroller">
            <table>
              <thead>
                <tr>
                  <th>{trans("tables.refNo")}</th>
                  <th>{trans("tables.name")}</th>
                  <th>{trans("tables.status")}</th>
                  <th>{trans("tables.activatedAt")}</th>
                  <th>Изтича на</th>
                  <th className="options">{trans("tables.options")}</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((warranty) => {
                  const daysUntilDue = moment(
                    warranty.expires_at_dmy,
                    "DD.MM.YYYY",
                  ).diff(moment(), "days")
                  const isOverdue = daysUntilDue <= 0
                  const isNear = daysUntilDue > 0 && daysUntilDue <= 20

                  return (
                    <tr key={"warranty-" + warranty.id}>
                      <td>{warranty.ref || "-"}</td>
                      <td>{warranty.name || "-"}</td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <span
                            style={{
                              width: "12px",
                              height: "12px",
                              borderRadius: "50%",
                              backgroundColor: warranty.is_active
                                ? "#4BB543"
                                : "#EC5252",
                            }}
                          ></span>
                          {warranty.is_active ? "Активен" : "Неактивен"}
                        </div>
                      </td>
                      <td>
                        {warranty.activated_at_dmy
                          ? moment(
                              warranty.activated_at_dmy,
                              "DD.MM.YYYY",
                            ).format("DD MMM YYYY")
                          : "-"}
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {!warranty.expires_at_dmy ? (
                            "-"
                          ) : (
                            <>
                              {isOverdue && (
                                <Tooltip title="Гаранцията е изтекла">
                                  <img src={alertImage} alt="" />
                                </Tooltip>
                              )}
                              {moment(
                                warranty.expires_at_dmy,
                                "DD.MM.YYYY",
                              ).format("DD MMM YYYY")}
                              {!isOverdue && (
                                <span
                                  style={isNear ? { color: "#EC5252" } : {}}
                                >{`(${daysUntilDue} дни)`}</span>
                              )}
                            </>
                          )}
                        </div>
                      </td>
                      <td>
                        <WarrantyOptions
                          id={warranty.id}
                          data={warranty}
                          handleEdit={handleEdit}
                          handleDelete={handleDelete}
                          handleActivate={handleActivate}
                          handleRenew={handleRenew}
                          handleDeactivate={handleDeactivate}
                        />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            pages={data.pages}
            page={data.page}
            handlePage={handlePage}
          />
        </>
      )}
    </div>
  )
}
